import { colors } from '../cssVariables'

export const Progress = {
  variants: {
    timer: {
      track: {
        bg: colors.colorB4,
        borderRadius: '20px',
        height: '20px',
        position: 'relative',
      },
      filledTrack: {
        bg: colors.colorA3,
      },
    },
  },
}
